import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BudgetsService {

  constructor(private http: HttpClient) {}

  getBudgetsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/budgets`);
  }

  updateBudgetsData(formsId: number, budgetsId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/budgets/${budgetsId}`, data);
  }
}
